const URL_PROTOCOL_REGEXP = /^(https?:\/\/)?(.*)/

function normalizeUrl(url) {
  // Ensure the URL has a protocol (default to http://)
  const match = URL_PROTOCOL_REGEXP.exec(url || '')
  if (match) {
    return (match[1] || 'http://') + match[2]
  }
}

module.exports = {
  normalizeUrl
}
